module.exports = __webpack_public_path__ + "static/media/squareHook.dfc8fa9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/squareHook.png
// module id = 766
// module chunks = 0 1